/* Landing Bundle — quantity tier sync (cross-section).
   v1.5.1 — Bundle ayrı section'a geri döndü (1.4.9 mimarisi); bundle root [data-bundle] ile
   bulunur (selector hem standalone section hem hero-block markup'ı için geçerli).
   Radio change'de Hero'nun hidden quantity input'u ve ATC total label'ı document scope'tan
   güncellenir. Editor'da bypass (designMode early return). */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function init() {
    document.querySelectorAll('[data-bundle]').forEach((bundleRoot) => {
      const radios = bundleRoot.querySelectorAll('.landing-hero-product__tier-radio');
      if (!radios.length) return;

      const apply = (radio) => {
        const qty = parseInt(radio.dataset.tierQty, 10) || 1;
        const total = parseInt(radio.dataset.tierTotal, 10);

        const qtyInput = document.querySelector('[data-quantity-input]');
        if (qtyInput) qtyInput.value = String(qty);

        const atcTotal = document.querySelector('[data-atc-total]');
        if (atcTotal && !isNaN(total)) {
          atcTotal.textContent = ' — ' + formatMoney(total);
        }
      };

      radios.forEach((r) => r.addEventListener('change', () => apply(r)));
      const checked = Array.from(radios).find((r) => r.checked);
      if (checked) apply(checked);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
